import { render, staticRenderFns } from "./perms.vue?vue&type=template&id=6a20a03b"
import script from "./perms.vue?vue&type=script&lang=js"
export * from "./perms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports